//
// 1:1 port of angular-filter's groupBy (site/js/angular-filter.js, a8m.group-by), used as
// `myFunctions | groupBy: 'can_description_i18n'`. A Map preserves the same key insertion order
// AngularJS' object-keyed ng-repeat relied on, without a pipe re-running the grouping every
// change-detection cycle - callers should wrap this in a computed().
//
export function groupBy<T>(items: readonly T[], keyFn: (item: T) => string): Map<string, T[]>
{
  const result = new Map<string, T[]>();
  for (const item of items)
  {
    const key = keyFn(item);
    const group = result.get(key);
    if (group)
    {
      group.push(item);
    }
    else
    {
      result.set(key, [item]);
    }
  }
  return result;
}
